export const Activity = [
  {
    path: '/activity/:app_module_id',
    name: 'activity.index',
    component: () => import('@/pages/Activity/ActivityModule')
  }
]
